import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 20,
  class: "text-brand-red"
}

import { computed, toValue } from 'vue';

import GeolocationField from 'SharedComponents/Fields/Types/Geolocation.vue';
import LabelField from 'SharedComponents/Fields/Types/LabelField.vue';
import ObjectField from 'SharedComponents/Fields/Types/ObjectField.vue';
import PictureField from 'SharedComponents/Fields/Types/Picture.vue';
import PictureGalleryField from 'SharedComponents/Fields/Types/PictureGallery.vue';
import SeparatorField from 'SharedComponents/Fields/Types/Separator.vue';
import TreeField from 'SharedComponents/Fields/Types/Tree.vue';
import VideoField from 'SharedComponents/Fields/Types/Video.vue';
import WysiwygField from 'SharedComponents/Fields/Types/Wysiwyg.vue';
import AddressValue from 'SharedComponents/Fields/ViewMode/AddressValue.vue';
import CheckboxValue from 'SharedComponents/Fields/ViewMode/CheckboxValue.vue';
import DateValue from 'SharedComponents/Fields/ViewMode/DateValue.vue';
import DynamicTableValue from 'SharedComponents/Fields/ViewMode/DynamicTableValue.vue';
import FileSampleField from 'SharedComponents/Fields/ViewMode/FileSample.vue';
import FileSetValue from 'SharedComponents/Fields/ViewMode/FileSetValue.vue';
import FileValue from 'SharedComponents/Fields/ViewMode/FileValue.vue';
import FixedTableValue from 'SharedComponents/Fields/ViewMode/FixedTableValue.vue';
import SelectValue from 'SharedComponents/Fields/ViewMode/SelectValue.vue';
import SimpleTextValue from 'SharedComponents/Fields/ViewMode/SimpleTextValue.vue';
import TreeSelectValue from 'SharedComponents/Fields/ViewMode/TreeSelectValue.vue';
import {
  ValuedFieldProps,
  defaultValuedProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldProp from 'SharedComponents/Fields/composables/useFieldProp';
import { PropValue } from 'SharedDir/common/composables/useValue';
import { Field, FieldValue } from 'SharedDir/declarations/fields';
import { WithRelations } from 'SharedDir/declarations/shared';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ViewFieldComponent' },
  __name: 'ViewFieldComponent',
  props: /*@__PURE__*/_mergeDefaults({
    modelValue: {},
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    field: {}
  }, defaultValuedProps),
  setup(__props: any) {


const props = __props;
const {
  itIsTextField,
  itIsTextareaField,
  itIsNumberField,
  itIsDateField,
  itIsCheckboxField,
  itIsSelectField,
  itIsFileField,
  itIsFileSetField,
  itIsAddressField,
  itIsFixedTableField,
  itIsDynamicTableField,
  itIsTreeSelectField,
  itIsObjectField,
  itIsWysiwygField,
  itIsLabelField,
  itIsPictureField,
  itIsPictureGalleryField,
  itIsVideoField,
  itIsGeolocationField,
  itIsTreeField,
  itIsFileSampleField,
  itIsSeparatorField,
} = useFieldProp(props);
const ifSimpleTextValue = computed(
  () => toValue(itIsTextField) || toValue(itIsTextareaField) || toValue(itIsNumberField)
);

const measureUnit = computed(() => props.field.measureUnit ?? { shortName: '' });

return (_ctx: any,_cache: any) => {
  return (ifSimpleTextValue.value)
    ? (_openBlock(), _createBlock(SimpleTextValue, {
        key: 0,
        "model-value": _ctx.modelValue,
        label: _ctx.label,
        unit: measureUnit.value,
        "show-history": _ctx.showHistory,
        history: _ctx.history,
        onRevealHistory: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
      }, null, 8, ["model-value", "label", "unit", "show-history", "history"]))
    : (_unref(itIsCheckboxField))
      ? (_openBlock(), _createBlock(CheckboxValue, {
          key: 1,
          "model-value": _ctx.modelValue,
          label: _ctx.label,
          "show-history": _ctx.showHistory,
          history: _ctx.history,
          onRevealHistory: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
        }, null, 8, ["model-value", "label", "show-history", "history"]))
      : (_unref(itIsDateField))
        ? (_openBlock(), _createBlock(DateValue, {
            key: 2,
            "model-value": _ctx.modelValue,
            label: _ctx.label,
            "show-history": _ctx.showHistory,
            history: _ctx.history,
            onRevealHistory: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
          }, null, 8, ["model-value", "label", "show-history", "history"]))
        : (_unref(itIsSelectField))
          ? (_openBlock(), _createBlock(SelectValue, {
              key: 3,
              "model-value": _ctx.modelValue,
              params: _ctx.field.params,
              label: _ctx.label,
              "show-history": _ctx.showHistory,
              history: _ctx.history,
              onRevealHistory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
            }, null, 8, ["model-value", "params", "label", "show-history", "history"]))
          : (_unref(itIsFileField))
            ? (_openBlock(), _createBlock(FileValue, {
                key: 4,
                "model-value": _ctx.modelValue,
                label: _ctx.label,
                "show-history": _ctx.showHistory,
                history: _ctx.history,
                onRevealHistory: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
              }, null, 8, ["model-value", "label", "show-history", "history"]))
            : (_unref(itIsFileSetField))
              ? (_openBlock(), _createBlock(FileSetValue, {
                  key: 5,
                  "model-value": _ctx.modelValue,
                  label: _ctx.label,
                  "show-history": _ctx.showHistory,
                  history: _ctx.history,
                  onRevealHistory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                }, null, 8, ["model-value", "label", "show-history", "history"]))
              : (_unref(itIsAddressField))
                ? (_openBlock(), _createBlock(AddressValue, {
                    key: 6,
                    "model-value": _ctx.modelValue,
                    label: _ctx.label,
                    "show-history": _ctx.showHistory,
                    history: _ctx.history,
                    onRevealHistory: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                  }, null, 8, ["model-value", "label", "show-history", "history"]))
                : (_unref(itIsFixedTableField))
                  ? (_openBlock(), _createBlock(FixedTableValue, {
                      key: 7,
                      "model-value": _ctx.modelValue,
                      field: _ctx.field,
                      label: _ctx.label,
                      "show-history": _ctx.showHistory,
                      history: _ctx.history,
                      onRevealHistory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                    }, null, 8, ["model-value", "field", "label", "show-history", "history"]))
                  : (_unref(itIsDynamicTableField))
                    ? (_openBlock(), _createBlock(DynamicTableValue, {
                        key: 8,
                        "model-value": _ctx.modelValue,
                        field: _ctx.field,
                        label: _ctx.label,
                        "show-history": _ctx.showHistory,
                        history: _ctx.history,
                        onRevealHistory: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                      }, null, 8, ["model-value", "field", "label", "show-history", "history"]))
                    : (_unref(itIsTreeSelectField))
                      ? (_openBlock(), _createBlock(TreeSelectValue, {
                          key: 9,
                          "model-value": _ctx.modelValue,
                          field: _ctx.field,
                          label: _ctx.label,
                          "show-history": _ctx.showHistory,
                          history: _ctx.history,
                          onRevealHistory: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                        }, null, 8, ["model-value", "field", "label", "show-history", "history"]))
                      : (_unref(itIsObjectField))
                        ? (_openBlock(), _createBlock(ObjectField, {
                            key: 10,
                            "model-value": _ctx.modelValue,
                            field: _ctx.field,
                            params: _ctx.field.params,
                            label: _ctx.label,
                            "show-history": _ctx.showHistory,
                            history: _ctx.history,
                            onRevealHistory: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('reveal-history', ...$event)))
                          }, null, 8, ["model-value", "field", "params", "label", "show-history", "history"]))
                        : (_unref(itIsLabelField))
                          ? (_openBlock(), _createBlock(LabelField, {
                              key: 11,
                              label: "",
                              params: _ctx.field.params
                            }, null, 8, ["params"]))
                          : (_unref(itIsWysiwygField))
                            ? (_openBlock(), _createBlock(WysiwygField, {
                                key: 12,
                                value: _ctx.modelValue,
                                label: "",
                                params: _ctx.field.params
                              }, null, 8, ["value", "params"]))
                            : (_unref(itIsPictureField))
                              ? (_openBlock(), _createBlock(PictureField, {
                                  key: 13,
                                  label: "",
                                  params: _ctx.field.params
                                }, null, 8, ["params"]))
                              : (_unref(itIsPictureGalleryField))
                                ? (_openBlock(), _createBlock(PictureGalleryField, {
                                    key: 14,
                                    label: "",
                                    params: _ctx.field.params
                                  }, null, 8, ["params"]))
                                : (_unref(itIsVideoField))
                                  ? (_openBlock(), _createBlock(VideoField, {
                                      key: 15,
                                      label: "",
                                      params: _ctx.field.params
                                    }, null, 8, ["params"]))
                                  : (_unref(itIsGeolocationField))
                                    ? (_openBlock(), _createBlock(GeolocationField, {
                                        key: 16,
                                        label: "",
                                        params: _ctx.field.params
                                      }, null, 8, ["params"]))
                                    : (_unref(itIsTreeField))
                                      ? (_openBlock(), _createBlock(TreeField, {
                                          key: 17,
                                          label: "",
                                          params: _ctx.field.params
                                        }, null, 8, ["params"]))
                                      : (_unref(itIsFileSampleField))
                                        ? (_openBlock(), _createBlock(FileSampleField, {
                                            key: 18,
                                            label: "",
                                            params: _ctx.field.params
                                          }, null, 8, ["params"]))
                                        : (_unref(itIsSeparatorField))
                                          ? (_openBlock(), _createBlock(SeparatorField, {
                                              key: 19,
                                              label: "",
                                              params: _ctx.field.params
                                            }, null, 8, ["params"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_1, " Отображение данного вида компонент (" + _toDisplayString(_ctx.field.fieldType.name) + ") еще не реализовано ", 1))
}
}

})